import React, { Component } from 'react'
import "./history.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'

export default class history extends Component {

    state = {
        content:`<p>      各区县科技局，有关企业：
        为持续开展科技型企业入库培育工作，针对性地支持科技型企业创新发展，决定开展2022年度科技型企业信息填报工作。现将有关事项通知如下：
  
        一、填报时间
        （一）已入库企业应于5月31日前更新年度数据信息。
        （二）新申请入库企业在“重庆市科技型企业系统”开通期间都可注册入库并填报数据信息。
        
        二、填报对象
        符合《重庆市科技型企业入库培育实施细则》（渝科局发〔2019〕136号）入库条件的企业。
        
        三、填报方式
        （一）已入库的科技型企业，账号不变，登录“重庆市科技型企业系统http://www.csti.cn/govwebnew/index.htm”填报。具体操作方法详见附件1。
        （二）未注册入库的企业，进入“重庆科技资源共享平台http://www.csti.cn/”，点击“立即注册”，选择“机构注册”，填写注册信息，完成企业账户注册后，登录“重庆市科技型企业系统”填报。
        （三）区县科技部门对辖区内企业填报的信息和证明材料进行完整性审核，将符合条件的企业在线提交至市科技局。具体操作方法详见附件2。
        
        四、注意事项
        （一）科技型企业应坚持诚实守信原则，据实填报数据信息，以便享受更加精准的服务和支持。
        （二）未在规定时间内填报数据信息的，视为自动放弃享受入库培育的相关服务和支持；填报虚假数据信息的，一经核实，将取消入库培育资格。
        
        联系人：</p>`,
        type:0,
    }

    componentWillMount(){
        window.scroll(0,0);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }

    render() {
        return (
            <div className='history'>
                <Header type={2} />
                <div className='cen'>
                    <div className='main'>
                        <div className='name'>
                            <p>当前位置：</p>
                            <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p className='i_point' onClick={()=>{this.gotoPage('/policySearch')}}>政策查询</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p className='i_point' onClick={()=>{window.history.go(-1)}}>政策详情</p>
                            <img alt="" src="/www/assets/imgs/xiaji.png" />
                            <p>资助历史</p>
                        </div>

                        <div className='box'>
                            <div className='left'>
                                <div className='top'>
                                    <h2>【福田】2018年福田区产业发展专项资金总部经济、现代服务业、供应链产业、先进制造业、专业服务业分项第十批支持企业及项目公告</h2>
                                    <div className='text'>
                                        <div>
                                            <p>信息来源：福田区工业和信息化局</p>
                                            <p>项目标签：贷款贴息贴保</p>
                                            <p>发布时间：2022.01.11</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='ptype'>
                                    <div className='pflex'>
                                        <div className={this.state.type === 0?'pfi pf_active':"pfi"} style={this.state.type === 0?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>公示通知</p>
                                        </div>
                                        <div className={this.state.type === 1?'pfi pf_active':"pfi"} style={this.state.type === 1?{backgroundImage:"url('/www/assets/imgs/fenlei.png')"}:{}}>
                                            <p>公示名单</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='name'>
                                    <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                    <h2>公示通知</h2>
                                </div>
                                <div className="cont" dangerouslySetInnerHTML={{
                                    __html: this.state.content
                                }}></div>
                                <div className='name'>
                                    <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                    <h2>公示名单</h2>
                                </div>
                                <div className='bom'>
                                    <a className="btn" href="/www/assets/imgs/icon.png" download="附件1：企业用户操作手册.pdf">附件1：企业用户操作手册.pdf</a>
                                    <a className="btn" href="/www/assets/imgs/icon.png" download="附件2：区县科技部门用户操作手册.pdf">附件2：区县科技部门用户操作手册.pdf</a>
                                </div>
                            </div>
                            <div className='right'>
                                <div className='rbox'>
                                    <div className='rname'>
                                        <img alt="" src="/www/assets/imgs/xiangqing-biaoti.png" />
                                        <p>相关政策</p>
                                    </div>
                                    <div className='text'>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                        <p>2021年四季度全市科技型企业培育情况最新报告</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
